export default "__VITE_ASSET__3e51acce__"